const errorBtn = document.getElementById('app-error-btn');



const ALLOWED_SOURCES = ['sugest.io', 'authland.com'];

errorBtn && errorBtn.addEventListener('click', (e) => {

    e.preventDefault();

    const connectSource = window.sessionStorage.getItem('connect.source');

    if (connectSource) {
        const connectSourceOrigin = new URL(connectSource).origin;

        if (ALLOWED_SOURCES.some((source) => connectSourceOrigin.endsWith(source))) {
            window.location.href = connectSource;
            return;
        }
    }

    // fallback to homepage
    window.location.href = '/';
});
